@use 'src/globals/main';

pn-counter {
  display: inline-block;
}

pn-counter .pn-counter {
  display: inline-flex;
  flex-direction: column;

  &-label {
    @include main.pn-input-label;
  }

  &-input {
    --pn-counter-ch: 0ch;
    @include main.pn-input-field;
    text-align: center;
    width: 100%;
    max-width: calc(3.5em + var(--pn-counter-ch));

    @include main.pn-focus;

    &:read-only {
      @include main.pn-readonly;
    }

    &:disabled {
      @include main.pn-disabled;
    }

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
    }

    &[type='number'] {
      appearance: textfield;
    }
  }

  &-items {
    display: inline-flex;
    flex-direction: row;
    gap: 0.5em;
    @include main.pn-transition('gap');

    &[data-hidebuttons] {
      gap: 0;
      > pn-button {
        transform: scale(0) translateZ(0);
        width: 0;
      }
    }

    > pn-button {
      transform: scale(1) translateZ(0);
      transform-origin: center center;
      width: 3em;
      @include main.pn-transition('transform, width');
    }
  }

  &-helpertext {
    @include main.pn-input-helpertext;
  }

  //hidden element with aria-live containing updates for screen reader
  @include main.pn-sr-only-class;
}
